import { useState, useEffect } from 'react';
import useUserStore from '../../stores/user-store';
import { settings } from '../../settings';

function SignIn() {
    const { setSessionToken, sessionToken } = useUserStore();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    useEffect(() => {
        if (sessionToken) return;

        // 1. Look for a token in the url for a temporary session:
        const url = new URL(window.location.href);
        const tempSessionToken = url.searchParams.get('token');
        if (tempSessionToken) {
            // Store temp token in sessionStorage
            sessionStorage.setItem('temp-session-token', tempSessionToken);

            // remove token from the url:
            url.searchParams.delete('token');
            window.history.pushState({}, document.title, url.href);

            setSessionToken(tempSessionToken);

            setTimeout(() => {
                setIsLoggedIn(true);
            }, 10);
            return;
        }

        // 2. Look for a temporary token stored in the session storage
        const tempSessionTokenInStorage = sessionStorage.getItem('temp-session-token');
        if (tempSessionTokenInStorage) {
            setSessionToken(tempSessionTokenInStorage);

            setTimeout(() => {
                setIsLoggedIn(true);
            }, 10);
            return;
        }

        // 3. Look for a persistent token stored in the local storage
        const persistentSessionToken = localStorage.getItem('session-token');
        if (persistentSessionToken) {
            setSessionToken(persistentSessionToken);

            setTimeout(() => {
                setIsLoggedIn(true);
            }, 10);

            return;
        }

        // No token yet, should show login UI:

        setIsRedirecting(true);
    }, [sessionToken, setSessionToken]);

    const [isRedirecting, setIsRedirecting] = useState(false);

    if (!isLoggedIn && isRedirecting) {
        window.location.href = `${settings.UI_SERVER_URL}/sign-in?redirect_url=${encodeURIComponent(
            window.location.href
        )}`;
    }
    return <></>;
}

export default SignIn;
